<div class="d-flex d-md-flex justify-content-between align-items-center m-b-10">
  <fui-heading [text]="'Firmware Instructions'" [level]="5"></fui-heading>
  <button class="btn btn-secondary" (click)="createDoc()">
    <fa-icon icon="plus"></fa-icon>
    Add
  </button>
</div>

@if (loading) {
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="firmware-instructions-loader"></myp-inline-loader>
}

@if (!loading && docs.length === 0) {
  <div class="text-center m-t-50">
    <span class="text-muted">No firmware instruction documents found.</span>
  </div>
}

@if (!loading && docs.length > 0) {
  @for (doc of docs; track doc.id) {
    <myp-list-item [title]="doc.title" [metadata]="doc._metadata" [includeChevron]="false" [includeBottomBorder]="true" [showImage]="false" (itemClicked)="editDoc(doc)">
      <div class="button-content">
        <fa-icon icon="edit" placement="left" (click)="editDoc(doc); $event.stopPropagation()" [ngbTooltip]="'Edit'" class="action circle-icon-btn m-r-10"></fa-icon>
        <fa-icon icon="times" placement="left" (click)="deleteDoc(doc); $event.stopPropagation()" [ngbTooltip]="'Delete'" class="action circle-icon-btn"></fa-icon>
      </div>
    </myp-list-item>
  }
}

<ng-template #deleteConfirmModal>
  <div class="modal-header">
    <h4 class="modal-title">Delete Instruction</h4>
  </div>
  <div class="modal-body">
    @if (docToDelete) {
      <p>Are you sure you want to delete "{{ docToDelete.title }}"? This cannot be undone.</p>
    }
    <div class="text-center">
      <button class="btn btn-danger" [disabled]="deleting" (click)="confirmDelete()">
        @if (deleting) {
          <fa-icon icon="spinner" animation="spin" class="m-r-5"></fa-icon>
        }
        Delete
      </button>
      <br />
      <br />
      <button class="btn btn-blank" [disabled]="deleting" (click)="cancelDelete()">Cancel</button>
    </div>
  </div>
</ng-template>
